// extracted by mini-css-extract-plugin
export default {"noDisplay":"CropImage_noDisplay__lMwts","containerPhoto":"CropImage_containerPhoto__BVoEx"};